import React from 'react'

import { Color, Link, LinkVariant, withCitrusTheme } from '@gousto-internal/citrus-react'

import type { CSSObject } from '@emotion/react'
import type { CtaLinkData } from './mapCmsCta'

export type CtaLinkProps = {
  cta?: CtaLinkData
  isLink?: boolean
}

const ButtonLink = withCitrusTheme(Link, (theme) => ({
  backgroundColor: theme.color(Color.Secondary_400),
  borderRadius: '3px',
  color: theme.color(Color.White),
  display: 'inline-block',
  fontWeight: 700,
  padding: '8px 24px',
  textAlign: 'center',
  ...(theme.responsiveStyle(['100%', 'auto'], ['width']) as CSSObject),
  '&:hover': {
    backgroundColor: theme.color(Color.Secondary_500),
    color: theme.color(Color.White),
  },
}))

const SecondaryButtonLink = withCitrusTheme(Link, (theme) => ({
  backgroundColor: theme.color(Color.White),
  border: `1px solid ${theme.color(Color.Secondary_400)}`,
  borderRadius: '3px',
  color: theme.color(Color.Secondary_400),
  display: 'inline-block',
  fontWeight: 700,
  padding: '8px 24px',
  textAlign: 'center',
  ...(theme.responsiveStyle(['100%', 'auto'], ['width']) as CSSObject),
  '&:hover': {
    backgroundColor: theme.color(Color.NeutralGrey_50),
    color: theme.color(Color.Secondary_500),
  },
}))

const InlineLink = withCitrusTheme(Link, () => ({
  color: 'inherit',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  textDecoration: 'none',
}))

export function CtaLink({ cta, isLink = false }: CtaLinkProps) {
  if (!cta?.text) {
    return null
  }

  if (isLink) {
    return (
      <InlineLink href={cta.href} onClick={cta.onClick} variant={LinkVariant.None}>
        {cta.text}
      </InlineLink>
    )
  }

  if (cta.variant === 'secondary') {
    return (
      <SecondaryButtonLink href={cta.href} onClick={cta.onClick} variant={LinkVariant.None}>
        {cta.text}
      </SecondaryButtonLink>
    )
  }

  return (
    <ButtonLink href={cta.href} onClick={cta.onClick} variant={LinkVariant.None}>
      {cta.text}
    </ButtonLink>
  )
}
